import { BreadcrumbItem, Breadcrumbs } from "@qws-org/ui-kit";
import type { FC, ReactNode } from "react";

import type { PageConstructorData } from "~/core/services/page-constructor.service";

type PageBreadcrumbsProps = {
  data: PageConstructorData;
  homeLabel?: string | null;
};

export const PageBreadcrumbs: FC<PageBreadcrumbsProps> = ({
  data,
  homeLabel = "Home",
}) => {
  const page = data.page;
  const parent = data.parentPage;

  const segment = page?.segment ?? "";
  const slug = page?.slug ?? "";

  const segmentLabel = parent?.preview_translations?.[0]?.title ?? segment;
  const slugLabel = page?.preview_translations?.[0]?.title ?? slug;

  const breadcrumbItems: Array<ReactNode> = [];

  if (homeLabel) {
    breadcrumbItems.push(
      <BreadcrumbItem href="/" variant="active" key="home">
        {homeLabel}
      </BreadcrumbItem>,
    );
  }

  if (segment) {
    breadcrumbItems.push(
      <BreadcrumbItem href={`/${segment}`} variant="active" key="segment">
        {segmentLabel}
      </BreadcrumbItem>,
    );
  }

  if (slug) {
    breadcrumbItems.push(
      <BreadcrumbItem
        href={segment ? `/${segment}/${slug}` : `/${slug}`}
        variant="disabled"
        key="slug"
      >
        {slugLabel}
      </BreadcrumbItem>,
    );
  }

  return (
    <Breadcrumbs
      maxWidth={1270}
      p={{ px: 15 }}
      m={{ mx: "auto" }}
      width="100%"
      aria-label="Navigation"
      className="px-4 lg:px-0"
      data-testid="breadcrumbs"
    >
      {breadcrumbItems}
    </Breadcrumbs>
  );
};
